import { POST_LIST_ITEMS_START } from '../../types';

export const post_list_items = (payload) => ({
  type: POST_LIST_ITEMS_START,
  payload,
});
